import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMobileServiceCountsQueryVariables = Types.Exact<{
  scope: Types.Mobility_Runs_Bool_Exp;
  window: Types.Mobility_Runs_Bool_Exp;
}>;


export type GetMobileServiceCountsQuery = { __typename?: 'query_root', upcoming: { __typename?: 'mobility_runs_aggregate', aggregate?: { __typename?: 'mobility_runs_aggregate_fields', count: number } | null }, active: { __typename?: 'mobility_runs_aggregate', aggregate?: { __typename?: 'mobility_runs_aggregate_fields', count: number } | null }, completed: { __typename?: 'mobility_runs_aggregate', aggregate?: { __typename?: 'mobility_runs_aggregate_fields', count: number } | null }, cancelled: { __typename?: 'mobility_runs_aggregate', aggregate?: { __typename?: 'mobility_runs_aggregate_fields', count: number } | null } };


export const GetMobileServiceCountsDocument = gql`
    query getMobileServiceCounts($scope: mobility_runs_bool_exp!, $window: mobility_runs_bool_exp!) {
  upcoming: mobility_runs_aggregate(
    where: {product_type: {_eq: "mobile_service"}, _and: [$scope, $window, {status: {_in: ["draft", "scheduled", "dispatched", "claimed"]}}]}
  ) {
    aggregate {
      count
    }
  }
  active: mobility_runs_aggregate(
    where: {product_type: {_eq: "mobile_service"}, _and: [$scope, $window, {status: {_in: ["in_transit"]}}]}
  ) {
    aggregate {
      count
    }
  }
  completed: mobility_runs_aggregate(
    where: {product_type: {_eq: "mobile_service"}, _and: [$scope, $window, {status: {_in: ["completed"]}}]}
  ) {
    aggregate {
      count
    }
  }
  cancelled: mobility_runs_aggregate(
    where: {product_type: {_eq: "mobile_service"}, _and: [$scope, $window, {status: {_in: ["cancelled", "canceled"]}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetMobileServiceCountsQuery__
 *
 * To run a query within a React component, call `useGetMobileServiceCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileServiceCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileServiceCountsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetMobileServiceCountsQuery(baseOptions: Apollo.QueryHookOptions<GetMobileServiceCountsQuery, GetMobileServiceCountsQueryVariables> & ({ variables: GetMobileServiceCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMobileServiceCountsQuery, GetMobileServiceCountsQueryVariables>(GetMobileServiceCountsDocument, options);
      }
export function useGetMobileServiceCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileServiceCountsQuery, GetMobileServiceCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMobileServiceCountsQuery, GetMobileServiceCountsQueryVariables>(GetMobileServiceCountsDocument, options);
        }
// @ts-ignore
export function useGetMobileServiceCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileServiceCountsQuery, GetMobileServiceCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobileServiceCountsQuery, GetMobileServiceCountsQueryVariables>;
export function useGetMobileServiceCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileServiceCountsQuery, GetMobileServiceCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobileServiceCountsQuery | undefined, GetMobileServiceCountsQueryVariables>;
export function useGetMobileServiceCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileServiceCountsQuery, GetMobileServiceCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMobileServiceCountsQuery, GetMobileServiceCountsQueryVariables>(GetMobileServiceCountsDocument, options);
        }
export type GetMobileServiceCountsQueryHookResult = ReturnType<typeof useGetMobileServiceCountsQuery>;
export type GetMobileServiceCountsLazyQueryHookResult = ReturnType<typeof useGetMobileServiceCountsLazyQuery>;
export type GetMobileServiceCountsSuspenseQueryHookResult = ReturnType<typeof useGetMobileServiceCountsSuspenseQuery>;
export type GetMobileServiceCountsQueryResult = Apollo.QueryResult<GetMobileServiceCountsQuery, GetMobileServiceCountsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (upcoming, active, completed, cancelled): returns the full response object.
 * @source {@link src/features/mobileService/counts/getMobileServiceCounts.query.gql}
 */
export async function getMobileServiceCounts(
  variables: GetMobileServiceCountsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetMobileServiceCountsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetMobileServiceCountsQuery>(
    GetMobileServiceCountsDocument,
    variables,
    requestOptions
  )
}